import React from "react";
import { Link } from "react-router-dom";
import { Heart, ArrowRight } from "lucide-react";
import { Button } from "components/ui/button";

const FavoritesEmptyState = ({ entityType }) => {
  const metaMap = {
    researchers: {
      title: "No favorite researchers yet",
      desc: "Save researchers from the search results to keep track of their citations, h-index, and latest publications.",
      link: "/explore/faculties",
      label: "Explore Researchers",
    },
    units: {
      title: "No favorite units yet",
      desc: "Bookmark university departments and research centers to follow their academic output and rankings.",
      link: "/explore/units",
      label: "Explore Units",
    },
    institutions: {
      title: "No favorite institutions yet",
      desc: "Add higher education institutions to your favorites to monitor their global performance and research.",
      link: "/explore/institutions",
      label: "Explore Institutions",
    },
    venues: {
      title: "No favorite venues yet",
      desc: "Bookmark journals and conferences to follow their publications, citations, and participating institutions.",
      link: "/explore/venues",
      label: "Explore Venues",
    },
  };

  const current = metaMap[entityType] || metaMap.researchers;

  return (
    <div className="flex flex-col items-center justify-center text-center p-12 sm:p-16 bg-white border border-dashed border-gray-300 rounded-xl flex-1 min-h-[480px] my-2 shadow-2xs">
      {/* Icon */}
      <div className="flex items-center justify-center w-16 h-16 rounded-2xl bg-slate-100 mb-6 border border-slate-200/60 shadow-2xs text-slate-500">
        <Heart size={28} className="stroke-[1.75]" />
      </div>

      {/* Title & Description & CTA */}
      <div className="flex flex-col items-center gap-3.5 max-w-md w-full mx-auto">
        <h3 className="text-lg font-semibold text-gray-900 tracking-tight">{current.title}</h3>
        <p className="text-sm text-gray-500 leading-relaxed max-w-[420px] mx-auto">{current.desc}</p>

        {/* Action Button */}
        <div className="pt-2.5">
          <Button
            asChild
            size="sm"
            className="h-9 px-5 gap-2 bg-explore hover:bg-explore/90 text-white font-medium text-xs rounded-md shadow-xs transition-all cursor-pointer"
          >
            <Link to={current.link}>
              {current.label}
              <ArrowRight size={14} />
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FavoritesEmptyState;
